export const isSameGeocodeRequest = (
  previousRequest: google.maps.GeocoderRequest | null,
  currentRequest: google.maps.GeocoderRequest,
): boolean => {
  if (!previousRequest) return false;

  if (previousRequest.location && currentRequest.location) {
    return (
      previousRequest.location.lat === currentRequest.location.lat &&
      previousRequest.location.lng === currentRequest.location.lng
    );
  }

  if (previousRequest.address && currentRequest.address) {
    return previousRequest.address === currentRequest.address;
  }

  return false;
};

export function buildGeocoderRequest(
  value: any,
): google.maps.GeocoderRequest | null {
  if (!value) return null;

  if (value.latitude && value.longitude) {
    return {
      location: { lat: value.latitude, lng: value.longitude },
    };
  }

  const lat = value?.geometry?.location?.lat;
  const lng = value?.geometry?.location?.lng;

  if (lat && lng) {
    return {
      location: {
        lat: typeof lat === 'function' ? lat() : lat,
        lng: typeof lng === 'function' ? lng() : lng,
      },
    };
  }

  if (value.formatted_address) {
    return { address: value.formatted_address };
  }

  if (value.address_string) {
    return { address: value.address_string };
  }

  return null;
}
